import { useState } from "react";

import { Connection } from "@zapier/client";
import { ConnectionModal } from "./types";

/** This hook manages state for Connection modals that appear as siblings to
 *  Connection tables in the UI.
 */

export function useConnectionModalStates() {
  const [currentConnectionModal, setCurrentConnectionModal] = useState<
    ConnectionModal | undefined
  >();
  const [currentConnection, setCurrentConnection] = useState<
    Connection | undefined
  >();

  return {
    currentConnection,
    currentConnectionModal,
    setCurrentConnection,
    setCurrentConnectionModal,
  };
}
